const initialState = {serviceUserDetailsCandidate: []}

export const serviceUserDetailsCandidate = (state = initialState, action) => {
	switch (action.type) {
  	case 'SET_SERVICE_USER_CANDIDATE_DETAILS':
      return {serviceUserDetailsCandidate: action.payload}; 
  }
  return state
}